import {
  BottomNavBar,
  TBottomNavBarProps,
} from './bottom-nav-bar';

export { BottomNavBar, type TBottomNavBarProps };
